// GoalsContext.ts
import React from 'react';
import { GoalType } from '../utils/apiRoutes';

// Define the shape of a single goal - matches WordPress API prepare_goal() response
export interface Goal {
  id: number;
  title: string;
  title_render: string;
  acf: { 
    [key: string]: any; // ACF fields can vary
    index?: string;
    name?: string;
    description?: string;
    status?: string | number;
    alignment_with_sdg_data?: {
      status?: string | number;
    };
    goal_color?: string;
    icon?: string;
  };
  computed?: {
    goal_semaphore_status?: string | number;
    goal_status_score?: number | null;
    goal_trend_status?: string | number;
    goal_trend_score?: number | null;
    goal_index_score?: number | null;
  };
  color?: string;
  icon?: string;
  featured_image_url?: string;
}

// Define the shape of the context value
interface GoalsContextType {
    goals: Goal[];
    globalGoals: Goal[];
    euGoals: Goal[];
    loading: boolean;
    initialLoading: boolean;
    error: string | null;
    selectedGoal: Goal | null;
    goalType: GoalType;
    fetchAllGoals: () => Promise<void>;
    setGoalType: (type: GoalType) => void;
    fetchGoals: (typeOverride?: GoalType) => Promise<void>;
    fetchGoal: (goalId: number) => Promise<Goal | null>;
    setSelectedGoal: (goal: Goal) => void;
}

export const defaultContextValue: GoalsContextType = {
  goals: [],
  globalGoals: [],
  euGoals: [],
  loading: false,
  initialLoading: true,
  error: null,
  selectedGoal: null,
  goalType: 'un',
  fetchAllGoals: async () => {},
  setGoalType: () => {},
  fetchGoals: async () => {},
  fetchGoal: async () => null,
  setSelectedGoal: () => {},
};
  
// Create the context
const GoalsContext = React.createContext<GoalsContextType>(defaultContextValue);

export { GoalsContext };